export default __webpack_public_path__ + "static/media/womancoding.0ae85796.jpg";